import React from 'react';
import AccessTitle from './AccessTitle';
import AccessGrid from './AccessGrid';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(5),
    },
  },
  wrapper: {
    padding: theme.spacing(4, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2.5, 0, 5),
    },
  },
  line: {
    [theme.breakpoints.only('xs')]: {
      width: '100%',
      borderBottom: '2px dotted #E8D6B3',
      marginBottom: theme.spacing(4),
    },
  },
  grid: {
    [theme.breakpoints.up('md')]: {
      paddingTop: `${theme.spacing(3)}px !important`,
    },
  },
}));

const KantoAccess = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AccessTitle type="train" />
      <div className={classes.wrapper}>
        <Grid container justify="center" spacing={2}>
          <Grid item xs={6} md={12}>
            <AccessGrid
              directions={[
                '東京駅',
                'JR新幹線かがやき\n（約2時間15分）',
                '富山駅',
                'JR特急ワイドビューひだ\n（約1時間15分）',
                '飛騨古川駅',
              ]}
            />
          </Grid>
          <Grid item xs={6} md={12} className={classes.grid}>
            <AccessGrid
              directions={[
                '東京駅',
                'JR新幹線のぞみ\n（約1時間40分）',
                '名古屋駅',
                'JR特急ワイドビューひだ\n（約2時間25分）',
                '高山駅',
                'JR高山本線\n（約15分）',
                '飛騨古川駅',
              ]}
            />
          </Grid>
        </Grid>
      </div>
      <div className={classes.line} />
      <AccessTitle type="bus" />
      <div className={classes.wrapper}>
        <AccessGrid
          directions={[
            '新宿駅',
            '濃飛バス・京王バス\n（約5時間30分）',
            [
              <span key="takayama">高山</span>,
              <span key="bus-center">バスセンター</span>,
            ],
            '濃飛バス\n（約35分）',
            '古川駅前',
          ]}
        />
      </div>
      <div className={classes.line} />
      <AccessTitle type="car" />
      <div className={classes.wrapper}>
        <AccessGrid
          directions={[
            '調布IC',
            '中央・長野自動車道\n（約2時間30分）',
            '松本IC',
            '国道158線・国道41号線\n（約2時間40分）',
            '飛騨古川',
          ]}
        />
      </div>
      <div className={classes.line} />
      <AccessTitle type="plane" />
      <div className={classes.wrapper}>
        <AccessGrid
          directions={[
            '羽田空港',
            'ANA\n（約1時間）',
            '富山空港',
            '富山地方鉄道\n（約25分）',
            '富山駅',
            'JR特急ワイドビューひだ\n（約1時間15分）',
            '飛騨古川駅',
          ]}
        />
      </div>
    </div>
  );
};

export default KantoAccess;
